/**
 * Runtime configuration helpers shared across screens. Ported from the
 * Operator UI's inline `isTruthyEnv` / feature-flag helpers (SkuBin.tsx:49-65)
 * so the scanner gates the Order Fulfillment module identically.
 */

export const isTruthyEnv = (value?: string): boolean => {
  if (!value) {
    return false;
  }
  return ["true", "1", "yes", "on"].includes(value.trim().toLowerCase());
};

const env = () => process.env as Record<string, string | undefined>;

export const isOrderToteMappingFeatureEnabled = (): boolean =>
  isTruthyEnv(env().REACT_APP_CARTE_PLUS_ENABLE_ORDER_TOTE_MAPPING);

export const isPutWallFeatureEnabled = (): boolean =>
  isTruthyEnv(env().REACT_APP_CARTE_PLUS_ENABLE_PUT_WALL);

/**
 * Order Fulfillment (tote mapping) needs both flags, matching the Operator UI
 * gate: `enablePutWallFeature && isOrderToteMappingFeatureEnabled()`.
 */
export const isOrderFulfillmentModuleEnabled = (): boolean =>
  isPutWallFeatureEnabled() && isOrderToteMappingFeatureEnabled();

/** Poll interval (ms); falls back to 5000 when the env var is missing/invalid. */
export const refreshDurationMs = (): number => {
  const parsed = Number(env().REACT_APP_REFRESH_DURATION);
  return parsed > 0 ? parsed : 5000;
};

/** Header/API convention shared by the whole backend: `tenantId: 1`. */
export const TENANT_HEADERS = {
  Accept: "application/json",
  tenantId: 1,
} as const;
